import { handleErrors } from "@/utils/handle-errors";
import fetch from "@mv/flow-shared-utils/functions/fetch";
export const findVersionInfoDictionary = () => ({ type: "findVersionInfoDictionary" });
export const findVersionInfoCore = () => ({ type: "findVersionInfoCore" });
export const findVersionInfoSdk = () => ({ type: "findVersionInfoSdk" });
export const findVersionInfoFlow = () => ({ type: "findVersionInfoFlow" });

export const actions = {
  findVersionInfoDictionary() {
    return fetch(`dictionary/actuator/info`)
      .then(handleErrors)
      .then((data) => data);
  },

  findVersionInfoCore() {
    return fetch(`core/actuator/info`)
      .then(handleErrors)
      .then((data) => data);
  },

  findVersionInfoSdk() {
    return fetch(`actuator/info`)
      .then(handleErrors)
      .then((data) => data);
  },

  findVersionInfoFlow() {
    return fetch(`flow/info`)
      .then(handleErrors)
      .then((data) => data);
  },
};
